// Key for storing the token in AsyncStorage
const TOKEN_KEY = 'adminToken';

/**
 * Saves the token to AsyncStorage.
 * @param {string} token - The token to save.
 */
export const saveToken = (token) => {
    try {
        localStorage.setItem(TOKEN_KEY, token);
        const token2 = localStorage.getItem(TOKEN_KEY);
        console.log('Token saved successfully',token2);
    } catch (error) {
        console.error('Error saving token:', error);
    }
};

/**
 * Retrieves the token from AsyncStorage.
 * @returns {Promise<string|null>} The retrieved token, or null if not found.
 */
export const getToken = () => {
    try {
        const token = localStorage.getItem(TOKEN_KEY);
        return token ? token : null;
    } catch (error) {
        console.error('Error retrieving token:', error);
        return null;
    }
};

/**
 * Decodes the JWT payload from the stored admin token.
 * Returns the full payload object so callers can inspect any claim.
 */
export const getTokenPayload = () => {
    const token = getToken();
    if (!token) return null;
    try {
        const parts = token.split('.');
        if (parts.length < 2) return null;
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(json);
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
};

/**
 * Returns the admin_id claim from the JWT, checking common claim names.
 */
export const getAdminId = () => {
    const payload = getTokenPayload();
    if (!payload) return null;
    return (
        payload.admin_id ||
        payload.adminId ||
        payload.id ||
        payload.user_id ||
        payload.sub ||
        null
    );
};

/**
 * Deletes the token from AsyncStorage.
 */
export const deleteToken = async () => {
    try {
        await localStorage.removeItem(TOKEN_KEY);
        console.log('Token deleted successfully');
    } catch (error) {
        console.error('Error deleting token:', error);
    }
};
